/**
 * Capitalize a string
 * @param {String} str
 */
export function capitalize(str: string): string {
    if (!str) return '';
    return str[0].toUpperCase() + str.substring(1);
}
